/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_PartnerInputs */

const en_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tree Partner`)
};

const ar_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شريك الشجرة`)
};

const de_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baumpartner`)
};

const es_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Socio de Reforestación`)
};

const fr_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partenaire`)
};

const it_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tree partner`)
};

const ja_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植樹パートナー`)
};

const ko_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트리 파트너`)
};

const pt_br_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parceria`)
};

const ru_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Партнёры деревьев`)
};

const th_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พันธมิตรการปลูกต้นไม้`)
};

const tr_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ağaç Ortağı`)
};

const zh_cn_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植树伙伴`)
};

const zh_tw_earth_day_2025_partner = /** @type {(inputs: Earth_Day_2025_PartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`植樹夥伴`)
};

/**
* | output |
* | --- |
* | "Tree Partner" |
*
* @param {Earth_Day_2025_PartnerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_partner = /** @type {((inputs?: Earth_Day_2025_PartnerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_PartnerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_partner(inputs)
	if (locale === "ar") return ar_earth_day_2025_partner(inputs)
	if (locale === "de") return de_earth_day_2025_partner(inputs)
	if (locale === "es") return es_earth_day_2025_partner(inputs)
	if (locale === "fr") return fr_earth_day_2025_partner(inputs)
	if (locale === "it") return it_earth_day_2025_partner(inputs)
	if (locale === "ja") return ja_earth_day_2025_partner(inputs)
	if (locale === "ko") return ko_earth_day_2025_partner(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_partner(inputs)
	if (locale === "ru") return ru_earth_day_2025_partner(inputs)
	if (locale === "th") return th_earth_day_2025_partner(inputs)
	if (locale === "tr") return tr_earth_day_2025_partner(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_partner(inputs)
	return zh_tw_earth_day_2025_partner(inputs)
});